import MultipleSearch from './MultipleSearch';
export default MultipleSearch;
//# sourceMappingURL=index.js.map
